<div class="main-page">
  <!-- <app-header></app-header> -->
  <app-common-header></app-common-header>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    <div class="sign-up-page-top">
      <div class="innerPage sign-up-page">
        <div class="sigup-screen-area mb-2">
          <p class="text-white h3">Create Your Free Profile</p>
          <div class="content-part"><img src="assets/logo-4.png"></div>
          <span class="text-white h2 font-weight-bold">Sign up</span>
        </div>
        <!-- <div class="sin-in-contnt"> -->
        <form class="form-signup" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
          <div class="form-group bg-eye-icon">
            <input type="email" class="form-control input-format" formControlName="email" placeholder="Email"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
            <!-- <img src="assets/eye.png" width=25 /> -->
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email is required</div>
              <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
            </div>
          </div>

          <div class="form-group bg-eye-icon" style="position: relative;">
            <input [type]="fieldTextType ? 'text' : 'password'" class="form-control input-format" formControlName="password"
              placeholder="Password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
            <i class="fa position" [ngClass]="{
            'fa-eye-slash': !fieldTextType,
            'fa-eye': fieldTextType
          }" title="Show Password" (click)="toggleFieldTextType('password')" aria-hidden="true"></i>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
              <div *ngIf="f.password.errors.required">Password is required</div>
              <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
            </div>
          </div>

          <div class="form-group bg-eye-icon retype" style="position: relative;">
            <input [type]="confirmFieldTextType ? 'text' : 'password'" formControlName="confirmPassword"
              class="form-control retype-password input-format" placeholder="Confirm Password"
              [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
            <i class="fa position" [ngClass]="{
            'fa-eye-slash': !confirmFieldTextType,
            'fa-eye': confirmFieldTextType
          }" title="Show Password" (click)="toggleFieldTextType('confirmPassword')" aria-hidden="true"></i>
            <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
              <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
              <div *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary">Sign Up</button>
        </form>
        <div class="mt-3">
          <small class="text-white mt-4">Already have an account? <span class="font-weight-bold h6 link-signin"
              routerLink="/login">Sign-in</span></small>
        </div>
      </div>
    </div>

    <!-- </div> -->
  </div>
</div>
